// extracted by mini-css-extract-plugin
export default {"stockIndicator":"dxhEAi","outOfStockIndicator":"c2lve_"};